import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { useToast } from "@/hooks/use-toast";
import ProprietarioForm from "@/components/proprietarios/ProprietarioForm";

export default function NovoProprietario() {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (data: any) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        toast({
          variant: "destructive",
          title: "Erro",
          description: "Usuário não autenticado",
        });
        return;
      }

      // Inserir proprietário
      const { data: ownerData, error: ownerError } = await supabase
        .from('profiles')
        .insert([{
          user_id: user.id,
          name: data.nome,
          email: data.email,
          phone: data.telefone,
          whatsapp: data.whatsapp,
          website: data.website,
        }])
        .select()
        .single();

      if (ownerError) throw ownerError;

      // Inserir imóvel
      if (data.propertyTitle) {
        const { error: propertyError } = await supabase
          .from('properties')
          .insert([{
            title: data.propertyTitle,
            address: data.propertyAddress,
            type: data.propertyType,
            sale_price: data.salePrice ? parseFloat(data.salePrice) : null,
            rent_price: data.rentPrice ? parseFloat(data.rentPrice) : null,
            seasonal_price: data.seasonalPrice ? parseFloat(data.seasonalPrice) : null,
            bedrooms: data.bedrooms ? parseInt(data.bedrooms) : null,
            bathrooms: data.bathrooms ? parseInt(data.bathrooms) : null,
            area: data.area ? parseFloat(data.area) : null,
            land_area: data.landArea ? parseFloat(data.landArea) : null,
            description: data.description,
            owner_id: ownerData.id
          }]);

        if (propertyError) throw propertyError;
      }

      toast({
        title: "Sucesso!",
        description: "Proprietário e imóvel cadastrados com sucesso.",
      });

      navigate("/proprietarios");
    } catch (error: any) {
      console.error('Erro ao cadastrar:', error);
      toast({
        variant: "destructive",
        title: "Erro ao cadastrar",
        description: error.message,
      });
    }
  };

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Novo Proprietário</h1>
      <ProprietarioForm onSubmit={handleSubmit} />
    </div>
  );
}